// extracted by mini-css-extract-plugin
export var alertDanger = "SignupForm-module--alert-danger--0d0e1";
export var alt = "SignupForm-module--alt--3fc4b";
export var container = "SignupForm-module--container--e6e86";
export var desktopOnly = "SignupForm-module--desktopOnly--81248";
export var disclaimer = "SignupForm-module--disclaimer--1ba0d";
export var formText = "SignupForm-module--formText--f4a62";
export var linkStyle = "SignupForm-module--link-style--49563";
export var main = "SignupForm-module--main--9badc";
export var mobileOnly = "SignupForm-module--mobileOnly--3c6dc";
export var textLeft = "SignupForm-module--textLeft--a8581";
export var travelPassInfo = "SignupForm-module--travelPassInfo--90f0d";
export var visuallyHidden = "SignupForm-module--visuallyHidden--aa68e";